import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'hooks/useRootStore';

const MyAlertDialog = observer(() => {
  const { alertStore } = useRootStore();

  const handleClose = (result?: boolean) => {
    alertStore.close();
    alertStore.onClose && alertStore.onClose(result);
  };
  const handleCloseMultiple = (result?: number) => {
    alertStore.close();
    alertStore.onCloseMultiple && alertStore.onCloseMultiple(result);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={alertStore.isOpen}
      onClose={() => {
        alertStore.mode === 'alert' && handleClose();
        // do nothing when confirm && click backdrop
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{alertStore.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {alertStore.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {alertStore.mode === 'alert' && (
          <Button onClick={() => handleClose()} autoFocus>
            {alertStore.closeBtn}
          </Button>
        )}
        {alertStore.mode === 'confirm' && (
          <>
            <Button onClick={() => handleClose(false)}>
              {alertStore.cancelBtn}
            </Button>

            <Button
              onClick={() => handleClose(true)}
              autoFocus
              color={alertStore.isDestructive ? 'error' : 'primary'}
            >
              {alertStore.confirmBtn}
            </Button>
          </>
        )}
        {alertStore.mode === 'multiple' && (
          <>
            <Button onClick={() => handleCloseMultiple()}>
              {alertStore.cancelBtn}
            </Button>

            {alertStore.actionBtns.map((actionBtn, i) => (
              <Button key={i} onClick={() => handleCloseMultiple(i)}>
                {actionBtn}
              </Button>
            ))}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
});

export default MyAlertDialog;
